import { render, staticRenderFns } from "./WidgetHead.vue?vue&type=template&id=55b10f26&scoped=true&"
import script from "./WidgetHead.vue?vue&type=script&lang=js&"
export * from "./WidgetHead.vue?vue&type=script&lang=js&"
import style0 from "./WidgetHead.vue?vue&type=style&index=0&id=55b10f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b10f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b10f26')) {
      api.createRecord('55b10f26', component.options)
    } else {
      api.reload('55b10f26', component.options)
    }
    module.hot.accept("./WidgetHead.vue?vue&type=template&id=55b10f26&scoped=true&", function () {
      api.rerender('55b10f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/modules/widget-preview/components/WidgetHead.vue"
export default component.exports